"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
/* eslint-disable no-process-env */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-c11fqje5"
});
const ErrorDetails = /*#__PURE__*/(0, _react2.styled)("details")({
  name: "ErrorDetails",
  class: "pc-e1hrup0q"
});
const ErrorSummary = /*#__PURE__*/(0, _react2.styled)("summary")({
  name: "ErrorSummary",
  class: "pc-e3bpozs"
});
const ErrorPre = /*#__PURE__*/(0, _react2.styled)("pre")({
  name: "ErrorPre",
  class: "pc-eo2e6ey"
});

/**
 * ErrorFallback Component
 *
 * @param {Object} props React props
 * @param {Error} props.error The error that occurred
 * @returns {React.ReactElement} ErrorFallback Component
 */
function ErrorFallback({
  error
}) {
  const environment = (0, _patternLibraryUtils.getDefaultEnv)();
  const isProduction = environment === 'prod';

  // Check if debug=true is in the URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const debugMode = urlParams.get('debug') === 'true';

  // Show detailed error: always in dev/test, in prod only with debug=true, or when test in local
  const shouldShowDebug = !isProduction || debugMode || window.location.hostname === 'localhost';
  const errorMessage = shouldShowDebug && error?.message || 'An unexpected error occurred';
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "title",
    text: "Something went wrong with this page",
    size: 3,
    "data-cy": "error-title"
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: errorMessage,
    size: 0,
    "data-cy": "error-message"
  }), shouldShowDebug && error?.stack && /*#__PURE__*/_react.default.createElement(ErrorDetails, null, /*#__PURE__*/_react.default.createElement(ErrorSummary, null, "Debug Mode"), /*#__PURE__*/_react.default.createElement(ErrorPre, null, error.stack)));
}
ErrorFallback.propTypes = {
  error: _propTypes.default.object
};
var _default = exports.default = ErrorFallback;